import {ConsoleInterceptorService} from './console-interceptor.service';

export function initialiseConsoleInterceptor(consoleInterceptor: ConsoleInterceptorService) {
  return (): Promise<any> => {
    return consoleInterceptor.init();
  };
}
